export let QuestionTypeInputTypeStrategy = {
  CHOICE: 'radio',
  MULTIPLE: 'checkbox',
  FREE_TEXT: 'text'
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/intake_survey/strategies/question_type_input_type_strategy.ts